export enum FacilityStatus {
    Active = "Active",
    ComingSoon = "ComingSoon",
    Archived = "Archived"
}
